(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TkbPaymentDialogController', TkbPaymentDialogController);

    TkbPaymentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'TkbPayment', 'Customer', 'Transaction'];

    function TkbPaymentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, TkbPayment, Customer, Transaction) {
        var vm = this;

        vm.tkbPayment = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.customers = Customer.query();
        vm.transactions = Transaction.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tkbPayment.id !== null) {
                TkbPayment.update(vm.tkbPayment, onSaveSuccess, onSaveError);
            } else {
                TkbPayment.save(vm.tkbPayment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:tkbPaymentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
